<template>
  <Dropdown type="text" v-model="data" :options="options" class="user-input" :style="{ 'width': width }" v-show="!show"
    @change="$emit('change', data)" id="dropdownLabel" />
  <label v-show="show">{{ data }}</label>
</template>

<script>

export default {
  name: 'DropdownLabel',
  props: {
    data: String,
    options: Array,
    show: Boolean,
    width: String
  }
}
</script>
<style scoped>
.user-input {
  height: 18px;
  font-family: 'Times New Roman', Times, serif;
  border: 1px solid #22b625;
}
</style>
<style>
#dropdownLabel .p-dropdown-label {
  line-height: 8px;
  font-size: 8px;
  font-family: 'Times New Roman', Times, serif;
}
</style>